<div class="admin-layout">
  <app-side-bar 
    [class.collapsed]="sidebarIsCollapsed"
    (sidebarCollapsed)="onSidebarCollapsed($event)">
  </app-side-bar>

  <div class="admin-content" [class.collapsed]="sidebarIsCollapsed">
    <app-banner 
      [adminUserInfo]="adminUserInfo" 
      [isAdminLoggedIn]="admin_logged_in"
      [tenantName]="tenantName">
    </app-banner>
    <div *ngIf="isLoading" class="loader-overlay">
        <span class="loader"></span>
    </div>
    <div class="admin-main-content">   
    <router-outlet></router-outlet>
    </div>
  </div>
</div>
